import { Money } from '../../../../types';
import { getTotalPrice } from './getTotalPrice';

export const sum = (...money: Money[]): Money => getTotalPrice(money, item => item);
